import script from "./AddPermissionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPermissionModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPermissionModal.vue?vue&type=style&index=0&id=76eec738&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76eec738"]])

export default __exports__